/* eslint-disable max-len */
/**
 * Finnish translations.
 */
export default {
  ACTION: {
    CANCEL: 'Peruuta',
    CONFIRM: 'Vahvista',
    SAVE: 'Tallenna',
    SEARCH: 'Etsi'
  },
  ERROR: {},
  HEADER: {
    EMAIL: 'Sähköposti',
    END_DATE: 'Loppupäivä',
    MEMBER_ID: 'Jäsenen tunnus',
    NAME: 'Nimi'
  },
  LABEL: {
    ALLOW_ADD_MEMBERS: 'Lisää jäseniä',
    CREATE_MEMBER: 'Lisää jäsen',
    DELETE_MEMBER_MODAL_TITLE: 'Jäsenen poistaminen',
    EDIT_MEMBER: 'Muokkaa jäsentä',
    EMAIL: 'Sähköposti',
    END_DATE: 'Loppupäivä',
    MEMBERS: 'Kumppanit',
    NAME: 'Nimi',
    NO: 'Ei',
    YES: 'Kyllä'
  },
  SENTENCE: {
    DELETE_MEMBER_TEXT: 'Oletko varma, että haluat poistaa kumppanin?',
    NO_MEMBER_NAME_EMAIL: 'Ei nimeä ja/tai sähköpostiosoitetta',
    NO_MEMBER_NAME_EMAIL_DETAIL: 'Kirjoita nimesi ja/tai sähköpostiosoitteesi',
    NO_ROWS_MEMBERS: 'Ei jäseniä',
    NO_ROWS_MEMBERS_DESCRIPTION: 'Muuta hakuehtoja'
  },
  SUCCESS: {
    MEMBER_DELETED: 'Kumppani onnistuneesti eliminoitu',
    MEMBER_DETAILS_SAVED: 'Jäsen onnistuneesti tallennettu',
    SUCCESS: 'Menestys'
  },
  TOOLTIP: {
    EDIT_MEMBER: 'Muokkaa jäsen',
    EMAIL: 'Sähköposti',
    END_DATE: 'Loppupäivä',
    MEMBER_ID: 'Jäsenen tunnus',
    NAME: 'Nimi',
    REMOVE_MEMBER: 'Poista jäsen'
  }
};
